import type { DefaultsLayer, InChannelRemindersMode, SettingView } from '../api/types';

export function layerLabel(layer: DefaultsLayer): string {
  if (layer === 'workspace') return 'Workspace override';
  return 'AckTracked default';
}

export function inChannelModeLabel(mode: InChannelRemindersMode): string {
  if (mode === 'private') return 'Private';
  if (mode === 'public') return 'Public';
  return 'No in-channel reminders';
}

export function formatLastUpdated(
  lastUpdated: string | null,
  lastUpdatedBy: string | null
): string | null {
  if (!lastUpdated) return null;
  const parsed = new Date(lastUpdated);
  const when = Number.isNaN(parsed.getTime()) ? lastUpdated : parsed.toLocaleString();
  if (lastUpdatedBy?.trim()) {
    return `${when} · ${lastUpdatedBy.trim()}`;
  }
  return when;
}

export function inForceLastUpdated(
  setting: SettingView<number> | SettingView<InChannelRemindersMode>
): string | null {
  if (setting.layer === 'workspace') {
    return formatLastUpdated(
      setting.workspace?.lastUpdated ?? null,
      setting.workspace?.lastUpdatedBy ?? null
    );
  }
  if (setting.layer === 'system') {
    return formatLastUpdated(setting.system.lastUpdated, setting.system.lastUpdatedBy);
  }
  return null;
}
